/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Contact_ColorInputs */

const en_tables_rule_sets_contact_color = /** @type {(inputs: Tables_Rule_Sets_Contact_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Contact Color`)
};

const de_tables_rule_sets_contact_color = /** @type {(inputs: Tables_Rule_Sets_Contact_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Sets Contact Color" |
*
* @param {Tables_Rule_Sets_Contact_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_contact_color = /** @type {((inputs?: Tables_Rule_Sets_Contact_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Contact_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_contact_color(inputs)
	return de_tables_rule_sets_contact_color(inputs)
});